import React from 'react';
import { Edit as IconEdit } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';

export default ({ user: { id } }) => (
  <Link to={`/user/${id}`}>
    <Tooltip title="Edit user">
      <IconButton aria-label="Edit user">
        <IconEdit />
      </IconButton>
    </Tooltip>
  </Link>
);
